import React, { createContext, useCallback, useMemo, useState } from 'react';

export type BannerId = 'unsaved-view-changes';

export interface BannerContextInterface {
  activeBanners: BannerId[];
  addBanner: (id: BannerId) => void;
  removeBanner: (id: BannerId) => void;
}

type BannerContextProps = {
  children?: React.ReactNode;
};

export const BannerContext = createContext<BannerContextInterface>({
  activeBanners: [],
  addBanner: () => {},
  removeBanner: () => {}
});

export const BannerProvider = ({ children }: BannerContextProps) => {
  const [activeBanners, setActiveBanners] = useState<BannerId[]>([]);

  const addBanner = useCallback((id: BannerId) => {
    setActiveBanners((banners) => (banners.includes(id) ? banners : [...banners, id]));
  }, []);

  const removeBanner = useCallback((id: BannerId) => {
    setActiveBanners((banners) =>
      !banners.includes(id) ? banners : banners.filter((b) => b !== id)
    );
  }, []);

  const value = useMemo(
    () => ({ activeBanners, addBanner, removeBanner }),
    [activeBanners, addBanner, removeBanner]
  );

  return <BannerContext.Provider value={value}>{children}</BannerContext.Provider>;
};
